import { gql } from '@apollo/client';

export const SAVE_FAIR_CODE = gql`
    mutation SaveFairCode($code: String!) {
        saveFairCode(code: $code) {
            code
        }
    }
`;
